import skills from './skills/v3/updateData';
import { sectionKeys, arraySections } from '../titleToSectionKeyDict';
import organizations from './organizations/v3/updateData';
import objective from './objective/v3/updateData';
import arrayItems from './array items/v3/updateData';
import updateUserPreferences from './getUserPreferences/v3/updateData';
import updateData from './letterBody/v3/updateData';

export default (params) => {
  const { fieldType } = params;
  if (fieldType === 'personalLinks' || arraySections[fieldType])
    return arrayItems(params);
  if (fieldType === 'skills') return skills(params);
  if (fieldType === 'objective') return objective(params);
  if (sectionKeys.includes(fieldType)) return organizations(params);
  if (fieldType === 'userPreferences') return updateUserPreferences(params);
  if (fieldType === 'letterBody') return updateData(params);

  return null;
};
